import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'tiktokAnalyticsKey',
  initialState: null as null | string,
  reducers: {
    setTiktokAnalyticsKey(state, action: PayloadAction<string | null>) {
      return action.payload || null;
    },
  },
});

export const { setTiktokAnalyticsKey } = slice.actions;

export default slice.reducer;
